<template>
  <div>
    <div class="content">
      <div class="field has-addons">
        <p class="control has-icons-left has-icons-right is-expanded">
          <input
            class="input is-loading is-large"
            type="text"
            placeholder="Enter your query"
            v-model="terms"
            @input="isTyping = true"
          />
          <span class="icon is-large is-left">
            <i class="zmdi zmdi-search"></i>
          </span>
          <span class="icon is-large is-right" v-if="isLoading">
            <i class="zmdi zmdi-refresh"></i>
          </span>
        </p>
      </div>

      <div class="card is-fullwidth">
        <header
          class="card-header is-clickable"
          @click="$refs.advSearch.classList.toggle('is-hidden')"
        >
          <span class="card-header-title">Advanced Search</span>
          <a class="card-header-icon card-toggle">
            <i class="zmdi zmdi-chevron-down"></i>
          </a>
        </header>
        <div class="card-content is-hidden" ref="advSearch">
          <div class="content">
            <b-field label="I only want to see">
              <div class="control" @change="search">
                <label class="checkbox">
                  <input type="checkbox" v-model="kinds" value="market" />
                  Markets&nbsp;
                </label>
                <label class="checkbox">
                  <input type="checkbox" v-model="kinds" value="site" />
                  Sites&nbsp;
                </label>
                <label class="checkbox">
                  <input type="checkbox" v-model="kinds" value="agent" />
                  Agents&nbsp;
                </label>
              </div>
            </b-field>
            <b-field label="Show me markets from the following catagories only">
              <div class="tags">
                <span class="tag is-success"
                  >Cattle Market<button class="delete is-small"></button
                ></span>
                <span class="tag is-success"
                  >Fat Market<button class="delete is-small"></button
                ></span>
                <span class="tag is-success"
                  >Livestock<button class="delete is-small"></button
                ></span>
              </div>
            </b-field>
            <b-field label="Show me markets between this date range">
              <b-datepicker
                placeholder="Click to select..."
                expanded
                v-model="dates"
                @input="search"
                range
                ><span class="icon">
                  <i class="zmdi zmdi-calendar"></i>
                </span>
              </b-datepicker>
              <p class="control">
                <a
                  class="button is-danger"
                  style="border-radius:4px"
                  @click="
                    dates = null
                    search()
                  "
                >
                  Reset
                </a>
              </p>
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <div v-if="results.length < 1" class="content">
      <p>No Results</p>
    </div>

    <div v-for="result in results" :key="result.hit.id" class="mb-4">
      <div
        v-if="result.kind == 'site'"
        class="columns site-highlight is-vcentered"
      >
        <div class="column is-narrow is-hidden-touch">
          <figure>
            <p class="image is-64x64">
              <img
                :src="
                  'https://my.biddingmate.com.au/logos/' +
                    result.payload.site +
                    '.png'
                "
                style="border-radius:10rem"
              />
            </p>
          </figure>
        </div>
        <div class="column">
          <a :href="'/site/' + result.payload.site"
            ><h1
              class="subtitle"
              v-if="result.hit.fragments['sitename'] != undefined"
              v-html="result.hit.fragments['sitename'][0]"
            ></h1>
            <h1 class="subtitle" v-else>
              {{ result.payload.sitename }}
            </h1></a
          >
          <small>{{ result.payload.location }}</small>
        </div>
        <div class="column is-narrow is-hidden-touch" title="Auction Site">
          <span class="icon is-medium is-right">
            <i class="zmdi zmdi-pin"></i>
          </span>
        </div>
      </div>
      <div v-if="result.kind == 'market'" class="columns is-vcentered">
        <div class="column is-narrow is-hidden-touch">
          <figure>
            <p class="image is-64x64">
              <img
                :src="
                  'https://my.biddingmate.com.au/logos/' +
                    result.payload.site +
                    '.png'
                "
                style="border-radius:10rem"
              />
            </p>
          </figure>
        </div>
        <div class="column">
          <a :href="'/market/' + result.payload.saleId"
            ><h1
              class="subtitle"
              v-if="
                result.hit.fragments != undefined &&
                  result.hit.fragments['saleDescription'] != undefined
              "
              v-html="result.hit.fragments['saleDescription'][0]"
            ></h1>
            <h1 class="subtitle" v-else>
              {{ result.payload.saleDescription }}
            </h1></a
          >
          <small
            >{{ result.payload.siteLocation }} |
            {{ result.payload.scheduled.toLocaleString() }}</small
          >
          <!--  -->
        </div>
        <div class="column is-narrow is-hidden-touch" title="Market Listing">
          <span class="icon is-medium is-right">
            <i class="zmdi zmdi-shopping-cart"></i>
          </span>
        </div>
      </div>
    </div>

    <!-- <div v-for="result in results" :key="result.hit.id" class="mb-4">
      <div v-for="(frag, field) in result.hit.fragments" :key="field">
        {{ field }}
        <div v-for="highlight in frag" :key="highlight">
          <p v-html="highlight"></p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<style scoped>
.site-highlight {
  background: #1e3459;
  /* background: radial-gradient(
    circle,
    rgba(22, 26, 66, 1) 0%,
    rgba(30, 52, 89, 1) 100%
  ); */
  border-radius: 12px;
}
</style>

<script>
import log from 'loglevel'

import Vue from 'vue'
import { Datepicker, Field } from 'buefy'
Vue.use(Datepicker)
Vue.use(Field)

export default {
  name: 'Search',
  metaInfo() {
    return {
      title: 'Search Results',
      meta: [
        {
          name: 'description',
          content: 'Search Results'
        }
      ]
    }
  },
  watch: {
    terms: function() {
      let ctx = this
      return this.debounce(function() {
        ctx.isTyping = false
      }, 250)
    },
    isTyping: function(value) {
      if (!value) {
        this.search()
      }
    }
  },
  data() {
    return {
      terms: '',
      kinds: [],
      dates: null,
      results: [],
      isTyping: false,
      isLoading: false,
      timeout: null
    }
  },
  mounted() {
    log.info('Search mounted')
  },
  destroyed() {
    log.info('Search destroyed')
  },
  methods: {
    search() {
      let ctx = this
      ctx.isLoading = true

      let query = {
        terms: ctx.terms,
        kinds: ctx.kinds
      }

      if (ctx.dates != null) {
        let last = new Date(ctx.dates[1])
        if (ctx.dates[0] == ctx.dates[1]) {
          log.info('Same day')
          last.setDate(last.getDate() + 1)
        }

        query.rangeStart = ctx.dates[0].toISOString()
        query.rangeEnd = last.toISOString()
      }

      fetch('/query', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        // headers: self.headers(),
        body: JSON.stringify(query)
      })
        .then(response => {
          ctx.isLoading = false
          if (response.ok) {
            return response.json()
          } else {
            log.error(
              'Server returned ' + response.status + ' : ' + response.statusText
            )
          }
        })
        .then(response => {
          response.forEach(result => {
            if (result.kind == 'market') {
              result.payload.scheduled = new Date(result.payload.scheduled)
              result.payload.timeStarted = new Date(result.payload.timeStarted)
              result.payload.timeFinished = new Date(
                result.payload.timeFinished
              )
            }
          })
          ctx.results = response
        })
        .catch(err => {
          log.error(err)
          ctx.isLoading = false
          //   reject(err)
        })
    },
    debounce(func, wait) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(function() {
        func()
      }, wait)
    }
  }
}
</script>
